export default __webpack_public_path__ + "static/media/qr-code-scan-2.1.fb58f2e4.png";